
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/[templateId]",
      function () {
        return require("private-next-pages/templates/[templateId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/[templateId]"])
      });
    }
  